export enum OrderState {
  CANCELED = 'canceled',
}

export enum PaymentMethod {
  CREDIT_CARD = 'CYBERSOURCE_CREDIT_CARD',
  PAY_PAL = 'PAYPAL',
  GOOGLE_PAY = 'GOOGLE_PAY',
  APPLE_PAY = 'APPLE_PAY',
  BREAD_PAYMENT = 'BREAD_PAYMENT',
}
